// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, doc, addDoc, setDoc, updateDoc, deleteDoc, getDoc, getDocs, query, where,
  orderBy,
  limit,
  startAfter } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDQzJYnh9UqrGb-NO5_mlWWEGkPSaPMHbc",
  authDomain: "admin-ciet.firebaseapp.com",
  projectId: "admin-ciet",
  storageBucket: "admin-ciet.firebasestorage.app",
  messagingSenderId: "238607689758",
  appId: "1:238607689758:web:6a57239bdc0ca307c1e60f",
  measurementId: "G-63Y7S2YJ3H"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
const customBucket = "gs://admin-ciet.firebasestorage.app";
export const customAttachmentStorage = getStorage(app, customBucket);
export {
  collection,
  doc,
  addDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  getDoc,
  getDocs,
  query,
  where,
  orderBy,
  limit,
  startAfter 
};